export default __webpack_public_path__ + "static/media/response_feedback.9fb36a1b.png";